/**
 * True when running inside Electron (most reliable signal for desktop builds).
 */
export const isElectronRuntime = () =>
  typeof navigator !== "undefined" && /Electron/i.test(navigator.userAgent);

/**
 * True when the native telephony IPC bridge from Electron preload is available.
 */
export const hasNativeTelephonyBridge = () =>
  Boolean(window.emmad?.telephony?.request);

/**
 * True when this session is the packaged/desktop shell (Electron or REACT_APP_DESKTOP build).
 */
export const isDesktopApp = () =>
  isElectronRuntime() ||
  process.env.REACT_APP_DESKTOP === "true" ||
  Boolean(window.emmad?.isDesktop);

/**
 * Grandstream UCM in Electron with the local SIP engine → native SIP (UDP/TCP), Wave Desktop–style.
 * All browser sessions use WebRTC over WSS via sip.js (Wave Web–style).
 */
export const shouldUseNativeSip = (providerName) =>
  providerName === "GRANDSTREAM_UCM" &&
  isElectronRuntime() &&
  hasNativeTelephonyBridge();

export const getAppTypeHeader = () => (isDesktopApp() ? "DESKTOP" : "WEB");

export const getTelephonyTransportLabel = (providerName) => {
  if (providerName === "D2C_CLOUD_PBX") {
    return "Linkus (Cloud PBX)";
  }
  if (providerName === "GRANDSTREAM_UCM") {
    return shouldUseNativeSip(providerName)
      ? "Native SIP (UDP/TCP)"
      : "WebRTC (UCM WSS)";
  }
  return "WebRTC (SIP)";
};
